const T_PREFIX = "not-found";

export const noItemsBannerTrns = {
  title: `${T_PREFIX}.no-items-banner.title`,
  description: `${T_PREFIX}.no-items-banner.description`,
  goHomeButton: `${T_PREFIX}.no-items-banner.go-home-btn`,
};
